import { render, staticRenderFns } from "./AlertMenu.vue?vue&type=template&id=48eabd6c&scoped=true"
import script from "./AlertMenu.vue?vue&type=script&lang=js"
export * from "./AlertMenu.vue?vue&type=script&lang=js"
import style0 from "./AlertMenu.vue?vue&type=style&index=0&id=48eabd6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eabd6c",
  null
  
)

export default component.exports